import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncateDecimal',
  pure: true,
})
export class TruncateDecimalPipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) private locale: string) {}

  transform(value: number | null | undefined, maxDecimals: number): string {
    const decimals = this.normalizeMaxDecimals(maxDecimals);
    const numericValue = this.toNumericValue(value);
    const factor = Math.pow(10, decimals);
    const truncated = Math.trunc(numericValue * factor) / factor;

    return new Intl.NumberFormat(this.locale, {
      minimumFractionDigits: 0,
      maximumFractionDigits: decimals,
    }).format(truncated);
  }

  private normalizeMaxDecimals(maxDecimals: number): number {
    if (!Number.isFinite(maxDecimals) || maxDecimals < 0) {
      return 0;
    }

    return Math.floor(maxDecimals);
  }

  private toNumericValue(value: number | null | undefined): number {
    if (value == null || !Number.isFinite(value)) {
      return 0;
    }

    return value;
  }
}
